import { InputStyled } from '@components/Common/SharedStyles';
import React from 'react';
import styled from 'styled-components';

const TextInputStyled = styled.input`
  ${InputStyled};
`;

export const TextInput: React.FC<any> = props => {
  return <TextInputStyled id={props.name} {...props}>{props.children}</TextInputStyled>;
};

export default TextInput;
